import Selectize from "selectize";
import $ from "jquery";

Selectize.define("selectize_a11y", function (options) {
  var self = this;
  var KEY_TAB = 9;
  var selectedOptionId = undefined;

  /**
   * Override onClick to set the openOnFocus on click the combobox control
   */
  this.onClick = (function () {
    var original = self.onClick;
    return function (e) {
      self.comboboxClicked = options.openOnClick ? options.openOnClick : true;
      return original.apply(this, arguments);
    };
  })();

  /**
   * Override onFocus to restore the original value of openOnFocus, when the focus is triggered by tab
   */
  this.onFocus = (function () {
    var original = self.onFocus;
    return function (e) {
      self.settings.openOnFocus = self.comboboxClicked
        ? self.comboboxClicked
        : false;
      var result = original.apply(this, arguments);

      // Reset comboboxClicked
      self.comboboxClicked = false;

      // Turn off openOnFocus by default
      self.settings.openOnFocus = false;
      return result;
    };
  })();

  /**
   * Override setActiveOption to set the following accessibility properties
   * listbox option - aria-selected
   * input control - aria-activedescendant
   */
  this.setActiveOption = (function () {
    var original = self.setActiveOption;
    return function ($option, scroll, animate) {
      // Save the attribute state before setting the active option
      var $previous = self.$activeOption;
      var $selected = $($option);
      var isExpanded = self.$control_input.attr("aria-expanded") === "true";

      if (!isExpanded && options.forceActiveDescendant) {
        self.$control_input.attr("aria-activedescendant", selectedOptionId);
      }

      // Set the new active option
      original.apply(this, arguments);

      // Remove the aria-selected from previous
      if ($previous) {
        $previous.removeAttr("aria-selected");
        $previous.removeAttr("aria-live");
      }

      if (!$selected.length) return;

      // Set the textbox activedescendant to the new selected option
      var optionId = $selected.attr("id");
      if (optionId && isExpanded) {
        // Set the text input active descendant to the active option
        self.$control_input.attr("aria-activedescendant", optionId);

        // Set the aria-selected on the new selected option
        $selected.attr("aria-selected", "true");
        $selected.attr("aria-live", "polite");
      }
    };
  })();

  /**
   * Override open
   * 1. Set the aria-expanded attribute
   */
  this.open = (function () {
    var original = self.open;
    return function () {
      original.apply(this, arguments);
      self.$control_input.attr("aria-expanded", "true");
    };
  })();

  /**
   * Override close to remove the input control aria-expanded and aria-activedescendant attributes
   */
  this.close = (function () {
    var original = self.close;
    return function () {
      original.apply(this, arguments);
      self.$control_input.attr("aria-expanded", "false");

      if (!options.forceActiveDescendant) {
        self.$control_input.removeAttr("aria-activedescendant");
      }
    };
  })();

  /**
   * Override onOptionSelect
   * 1. To set the focus back to control
   * 2. To update the textbox description on the selected option
   */
  this.onOptionSelect = (function () {
    var original = self.onOptionSelect;
    return function () {
      original.apply(this, arguments);

      // Update the textbox description to the selected option
      self.$control_input.attr("aria-describedby", getTextboxDescIds());

      // Setting the focus causes the listbox to show
      self.settings.openOnFocus = false;
      self.focus();
    };
  })();

  /**
   * Override setup to set initial accessibility properties
   * Using ARIA 1.0 Combobox pattern
   * 1. container
   * 2. input control
   * 3. dropdown
   */
  this.setup = (function () {
    var original = self.setup;
    return function () {
      // Accessibility for single selected item when hideSelected is true
      // force the selectedOptionId to be aria-activedescendant
      // when selectize is onFocus
      if (options.forceActiveDescendant) {
        const renderItem = self.settings.render.item;
        self.settings.render.item = function (item) {
          const html = renderItem.apply(self, arguments);
          const optionId = $(html).attr("id"); // Get selected option id
          selectedOptionId = item ? optionId : undefined;
          return html;
        };
      }
      original.apply(this, arguments);

      var listboxId = options.id + "-listbox";
      var textboxId = options.textboxId
        ? options.textboxId
        : options.id + "-textbox";

      // Set the accessibility properties of the text input
      self.$control_input.attr({
        id: textboxId,
        role: "combobox",
        "data-allownew": options.allowNew,
        "aria-autocomplete": "list",
        "aria-haspopup": "true",
        "aria-owns": listboxId,
        "aria-expanded": "false",
        "aria-labelledby": options.labelId ? options.labelId : null,
        "aria-label": !options.labelId ? options.label : null
      });

      // Set the accessibility properties of the dropdown
      self.$dropdown.attr({
        role: "listbox",
        id: listboxId,
        "aria-labelledby": options.labelId ? options.labelId : null,
        "aria-label": !options.labelId ? options.label : null
      });
      self.$dropdown_content.attr({
        role: "presentation"
      });

      // Set the textbox description to be provide feedback on the current item
      // Currently, when there is selected item, the textbox input control is set to blank
      self.$control_input.attr("aria-describedby", getTextboxDescIds());

      // Override the input text autocomplete attribute value.
      // The selectize sets to input text autocomplete to "off" by default
      if (options.autofillToken) {
        self.$control_input.attr("autocomplete", options.autofillToken);
      }
    };
  })();

  /**
   * Return space-separated IDs for the textbox description
   */
  var getTextboxDescIds = function () {
    var ids = options.selectItemIds;
    return ids && ids.length > 0 ? ids.join(" ") : null;
  };
});
